var map = {
	"./agn.jpeg": 285,
	"./cryptocurrency.png": 502,
	"./lasertag.png": 495,
	"./pathfinder.png": 684,
	"./portrait.jpg": 873,
	"./resume.pdf": 162,
	"./ricoh.png": 707,
	"./snakeai.png": 987,
	"./walmart.png": 743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;